// services/packagesApi.js

import axios from "axios";
import { makeRequest } from "../utils/handleJWT";

const PACKAGES_API_URL =
  "https://umlang.com/packages/api/v1/packages/getpackageslist";

/**
 * دریافت لیست پکیج‌های اشتراک
 */
export const getPackagesList = async () => {
  return makeRequest(async () => {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      PACKAGES_API_URL,
      {}, // بادی خالی
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  });
};
